<template>
  <div class="dl-root">
    <main class="dl-home">
      <!-- 顶部标题栏 -->
      <header class="dl-header">
        <div class="dl-header-top">
          <div class="dl-back-btn" @click.stop="goBack()">
            <di-icon icon="solar:arrow-left-linear" :width="20" />
          </div>
          <span class="dl-header-center">详情</span>
          <span class="dl-header-center"></span>
        </div>
        <div class="dl-mirror-head">
          <span class="dl-mirror-badge">
            <di-icon icon="simple-icons:microsoft" :width="24" />
          </span>
          <div>
            <p class="dl-mirror-from">From iWin11.cn</p>
            <h1 class="dl-mirror-title">{{ mirrorKey }}</h1>
          </div>
        </div>
      </header>

      <!-- 可滚动内容区 -->
      <section class="dl-scroll">
        <div class="dl-page">
          <div class="dl-detail-cols">
            <!-- 累计下载卡片 -->
            <div class="dl-summary-card">
              <div class="dl-summary-top">
                <div>
                  <p class="dl-summary-label">累计下载</p>
                  <div class="dl-summary-nums">
                    <strong class="dl-summary-value">{{ currentMirror.total }}</strong>
                    <span class="dl-summary-delta" :style="{color: currentMirror.growth < 0 ? '#fb7185': '#6ee7b7'}">{{ currentMirror.growth > 0 ? '+'+currentMirror.growth : currentMirror.growth }}%</span>
                  </div>
                </div>
                <span class="dl-summary-range">{{ rangeOptions[range] }}</span>
              </div>
              <div class="dl-summary-grid">
                <div>
                  <p class="dl-summary-cell-k">日均</p>
                  <p class="dl-summary-cell-v">{{ currentMirror.avg }}</p>
                </div>
                <div>
                  <p class="dl-summary-cell-k">最高日</p>
                  <p class="dl-summary-cell-v">{{ currentMirror.peak }}</p>
                </div>
                <div>
                  <p class="dl-summary-cell-k">占全站</p>
                  <p class="dl-summary-cell-v">{{ currentMirror.rate }}%</p>
                </div>
              </div>
            </div>

            <!-- 下载趋势 -->
            <div class="dl-trend-block">
              <div class="dl-trend-head">
                <div>
                  <h2 class="dl-section-title">下载趋势</h2>
                  <p class="dl-trend-sub">每日合计 · 单位：次</p>
                </div>
              </div>
              <div class="dl-chart-card">
                <div class="dl-chart" ref="detailChart"></div>
              </div>
            </div>
          </div>

          <!-- 下载方式明细 -->
          <div class="dl-channel-head">
            <div>
              <h2 class="dl-section-title">下载方式明细</h2>
              <p class="dl-trend-sub">渠道贡献与占比</p>
            </div>
            <button type="button" class="dl-sort-btn" @click="toggleSort">
              {{ sortLabel }}
              <di-icon icon="solar:sort-vertical-linear" :width="14" />
            </button>
          </div>
          <div class="dl-channel-list">
            <div class="dl-channel-item" v-for="(item, index) in sortedChannels" :key="item.name">
              <span class="dl-channel-icon"><di-icon icon="solar:bolt-bold-duotone" :width="18" /></span>
              <div class="dl-channel-body">
                <div class="dl-channel-row">
                  <span class="dl-channel-name">{{ item.name }}</span>
                  <strong class="dl-channel-nums">{{ item.num }}<span class="dl-channel-percent">{{ item.proportion }}%</span></strong>
                </div>
                <div class="dl-channel-bar">
                  <div class="dl-channel-bar-fill" :style="{ width: item.proportion + '%', backgroundColor: colorList[index] }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getSystemStatisticsDetail, getSystemStatisticsDetailByDrive} from "../../api/SoftwareDownloads";

/**
 * 图标数据（来自 Iconify 的 solar / simple-icons 图标集，已内联为 SVG path）
 * 新增图标时按 "前缀:名称": "SVG 内容" 追加即可，颜色跟随 currentColor。
 */
const ICONS = {
  "solar:arrow-left-linear": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M20 12H4M10 18L4 12L10 6\"/>",
  "solar:share-linear": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"><path d=\"M19.5 5.5C19.5 6.88071 18.3807 8 17 8C15.6193 8 14.5 6.88071 14.5 5.5C14.5 4.11929 15.6193 3 17 3C18.3807 3 19.5 4.11929 19.5 5.5Z\"/><path d=\"M17 16C15.6193 16 14.5 17.1193 14.5 18.5C14.5 19.8807 15.6193 21 17 21C18.3807 21 19.5 19.8807 19.5 18.5C19.5 17.1193 18.3807 16 17 16Z\"/><path d=\"M7 9.5C5.61929 9.5 4.5 10.6193 4.5 12C4.5 13.3807 5.61929 14.5 7 14.5C8.38071 14.5 9.5 13.3807 9.5 12C9.5 10.6193 8.38071 9.5 7 9.5Z\"/><path d=\"M9.09668 13.3628C11.0324 14.621 12.9681 15.8792 14.9038 17.1374\"/><path d=\"M9.09668 10.6372C11.0324 9.379 12.9681 8.12079 14.9039 6.86258\"/></g>",
  "solar:sort-vertical-linear": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"><path d=\"M16 18L16 6M12 10.125L16 6L20 10.125\"/><path d=\"M8 6L8 18M4 13.875L8 18L12 13.875\"/></g>",
  "solar:bolt-bold-duotone": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M8.73167 5.77133L5.66953 9.91436C4.3848 11.6526 3.74244 12.5217 4.09639 13.205C4.10225 13.2164 4.10829 13.2276 4.1145 13.2387C4.48945 13.9117 5.59888 13.9117 7.81775 13.9117C9.05079 13.9117 9.6673 13.9117 10.054 14.2754L10.074 14.2946L13.946 9.72466L13.926 9.70541C13.5474 9.33386 13.5474 8.74151 13.5474 7.55682V7.24712C13.5474 3.96249 13.5474 2.32018 12.6241 2.03721C11.7007 1.75425 10.711 3.09327 8.73167 5.77133Z\" clip-rule=\"evenodd\"/><path d=\"M10.4527 16.4432L10.4527 16.7528C10.4527 20.0374 10.4527 21.6798 11.376 21.9627C12.2994 22.2457 13.2891 20.9067 15.2685 18.2286L18.3306 14.0856C19.6154 12.3474 20.2577 11.4783 19.9038 10.7949C19.8979 10.7836 19.8919 10.7724 19.8857 10.7613C19.5107 10.0883 18.4013 10.0883 16.1824 10.0883C14.9494 10.0883 14.3329 10.0883 13.9462 9.72461L10.0742 14.2946C10.4528 14.6661 10.4527 15.2585 10.4527 16.4432Z\" opacity=\".5\"/></g>",
  "solar:cloud-bold-duotone": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M22 14.3529C22 17.4717 19.4416 20 16.2857 20H10.4995C9.55792 18.7465 9 17.1884 9 15.5C9 11.3579 12.3579 8 16.5 8C17.009 8 17.5062 8.05071 17.9868 8.14736C18.0649 8.42841 18.1216 8.71822 18.1551 9.01498C20.393 9.78024 22 11.8811 22 14.3529Z\" clip-rule=\"evenodd\" opacity=\".5\"/><path d=\"M12.4762 4C9.32028 4 6.7619 6.52827 6.7619 9.64706C6.7619 10.3369 6.88706 10.9978 7.11616 11.6089C6.8475 11.5567 6.56983 11.5294 6.28571 11.5294C3.91878 11.5294 2 13.4256 2 15.7647C2 18.1038 3.91878 20 6.28571 20H10.4995C9.55792 18.7465 9 17.1884 9 15.5C9 11.3579 12.3579 8 16.5 8C17.009 8 17.5062 8.05071 17.9868 8.14736C17.9721 8.09441 17.9566 8.04178 17.9403 7.98948C17.2237 5.67956 15.0484 4 12.4762 4Z\"/></g>",
  "solar:cloud-storage-bold-duotone": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M8.93934 14.4393C8.5 14.8787 8.5 15.5858 8.5 17V19C8.5 20.4142 8.5 21.1213 8.93934 21.5607C9.37868 22 10.0858 22 11.5 22H12.5C13.9142 22 14.6213 22 15.0607 21.5607C15.5 21.1213 15.5 20.4142 15.5 19V17C15.5 15.5858 15.5 14.8787 15.0607 14.4393C14.6213 14 13.9142 14 12.5 14H11.5C10.0858 14 9.37868 14 8.93934 14.4393ZM10.25 18C10.25 17.5858 10.5858 17.25 11 17.25H13C13.4142 17.25 13.75 17.5858 13.75 18C13.75 18.4142 13.4142 18.75 13 18.75H11C10.5858 18.75 10.25 18.4142 10.25 18Z\" clip-rule=\"evenodd\"/><path d=\"M22 12.3529C22 15.2327 19.8188 17.6089 17 17.9563L15.5 17.9629V17C15.5 15.5858 15.5 14.8787 15.0607 14.4393C14.6213 14 13.9142 14 12.5 14H11.5C10.0858 14 9.37868 14 8.93934 14.4393C8.5 14.8787 8.5 15.5858 8.5 17V17.9934L7.00002 18H6.28571C3.91878 18 2 16.1038 2 13.7647C2 11.4256 3.91878 9.52941 6.28571 9.52941C6.56983 9.52941 6.8475 9.55673 7.11616 9.60887C6.88706 8.9978 6.7619 8.33687 6.7619 7.64706C6.7619 4.52827 9.32028 2 12.4762 2C15.4159 2 17.8371 4.19371 18.1551 7.01498C20.393 7.78024 22 9.88113 22 12.3529Z\" opacity=\".5\"/></g>",
  "solar:cloud-check-bold-duotone": "<g fill=\"currentColor\"><path d=\"M6.50001 18L6.50001 17.9105C6.49991 17.0449 6.49981 16.2512 6.58661 15.6056C6.6822 14.8946 6.90709 14.1432 7.52514 13.5251C8.14319 12.9071 8.89464 12.6822 9.6056 12.5866C10.2512 12.4998 11.0449 12.4999 11.9105 12.5H12.0895C12.9551 12.4999 13.7488 12.4998 14.3944 12.5866C15.1054 12.6822 15.8568 12.9071 16.4749 13.5251C17.0929 14.1432 17.3178 14.8946 17.4134 15.6056C17.4989 16.2417 17.5001 17.0215 17.5 17.8722C20.0726 17.3221 22 15.0599 22 12.3529C22 9.88113 20.393 7.78024 18.1551 7.01498C17.8371 4.19371 15.4159 2 12.4762 2C9.32028 2 6.7619 4.52827 6.7619 7.64706C6.7619 8.33687 6.88706 8.9978 7.11616 9.60887C6.8475 9.55673 6.56983 9.52941 6.28571 9.52941C3.91878 9.52941 2 11.4256 2 13.7647C2 16.1038 3.91878 18 6.28571 18L6.50001 18Z\" opacity=\".5\"/><path fill-rule=\"evenodd\" d=\"M12 22C10.1144 22 9.17157 22 8.58579 21.4142C8 20.8284 8 19.8856 8 18C8 16.1144 8 15.1716 8.58579 14.5858C9.17157 14 10.1144 14 12 14C13.8856 14 14.8284 14 15.4142 14.5858C16 15.1716 16 16.1144 16 18C16 19.8856 16 20.8284 15.4142 21.4142C14.8284 22 13.8856 22 12 22ZM14.2492 17.1381C14.5095 16.8777 14.5095 16.4556 14.2492 16.1953C13.9888 15.9349 13.5667 15.9349 13.3064 16.1953L11.1111 18.3905L10.6936 17.973C10.4333 17.7127 10.0112 17.7127 9.75082 17.973C9.49047 18.2334 9.49047 18.6555 9.75082 18.9158L10.6397 19.8047C10.9001 20.0651 11.3222 20.0651 11.5825 19.8047L14.2492 17.1381Z\" clip-rule=\"evenodd\"/></g>",
  "solar:clouds-bold-duotone": "<g fill=\"currentColor\"><path d=\"M16.2857 18C19.4416 18 22 15.4717 22 12.3529C22 9.88113 20.393 7.78024 18.1551 7.01498C17.8371 4.19371 15.4159 2 12.4762 2C9.32028 2 6.7619 4.52827 6.7619 7.64706C6.7619 8.33687 6.88706 8.9978 7.11616 9.60887C6.8475 9.55673 6.56983 9.52941 6.28571 9.52941C3.91878 9.52941 2 11.4256 2 13.7647C2 16.1038 3.91878 18 6.28571 18H16.2857Z\" opacity=\".5\"/><path d=\"M18.2857 22C20.3371 22 22 20.4198 22 18.4706C22 16.9257 20.9554 15.6126 19.5008 15.1344C19.2941 13.3711 17.7203 12 15.8095 12C13.7582 12 12.0952 13.5802 12.0952 15.5294C12.0952 15.9605 12.1766 16.3736 12.3255 16.7555C12.1509 16.723 11.9704 16.7059 11.7857 16.7059C10.2472 16.7059 9 17.891 9 19.3529C9 20.8149 10.2472 22 11.7857 22H18.2857Z\"/></g>",
  "solar:box-bold-duotone": "<g fill=\"currentColor\"><path d=\"M12 2C12.9441 2.0001 13.8219 2.46071 15.5771 3.38184L17.5771 4.43164C19.6806 5.53549 20.7561 6.0997 21.3613 7.07227C21.3751 7.09433 21.3891 7.11715 21.4023 7.13965C21.9997 8.15413 22 9.41671 22 11.9414V12.0586C22 14.5834 21.9997 15.8458 21.4023 16.8604C20.805 17.8747 19.7294 18.4394 17.5781 19.5684L15.5781 20.6182C13.8225 21.5395 12.9443 22 12 22V12L2.6377 7.07227C3.24293 6.09963 4.31839 5.5355 6.42188 4.43164L8.42188 3.38184C10.1775 2.46053 11.0557 2 12 2Z\" opacity=\".5\"/><path d=\"M17.5774 4.43152L15.5774 3.38197C13.8218 2.46066 12.944 2 11.9997 2C11.0554 2 10.1776 2.46066 8.42197 3.38197L6.42197 4.43152C4.31821 5.53552 3.24291 6.09982 2.6377 7.07264L11.9997 12L21.3617 7.07264C20.7564 6.09982 19.6811 5.53552 17.5774 4.43152Z\" opacity=\".5\"/><path d=\"M17.0166 8.65332L21.041 6.6416C21.1786 6.79744 21.2985 6.96157 21.4033 7.13965C21.5529 7.39367 21.665 7.66382 21.749 7.96484L17.75 9.96387V13C17.75 13.4142 17.4142 13.75 17 13.75C16.5859 13.7498 16.25 13.4141 16.25 13V10.7139L12.75 12.4639V21.9043C12.4932 21.9682 12.2488 22 12 22C11.8814 22 11.7639 21.9921 11.6455 21.9775C11.5936 21.9712 11.5416 21.9633 11.4893 21.9541C11.4815 21.9527 11.4736 21.9516 11.4658 21.9502C11.4324 21.9441 11.399 21.9369 11.3652 21.9297C11.3272 21.9215 11.2886 21.9139 11.25 21.9043C10.5321 21.7255 9.71471 21.2966 8.42188 20.6182L6.42188 19.5684C4.27056 18.4394 3.19502 17.8747 2.59766 16.8604C2.00026 15.8458 2 14.5834 2 12.0586V11.9414C2 9.41671 2.00028 8.15413 2.59766 7.13965C2.70253 6.96159 2.82237 6.79743 2.95996 6.6416L12 11.1621L15.3867 9.46875L6.32324 4.4834C6.35604 4.46618 6.38954 4.44912 6.42285 4.43164L7.91602 3.64746L17.0166 8.65332Z\"/></g>",
  "solar:download-square-bold-duotone": "<g fill=\"currentColor\"><path d=\"M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z\" opacity=\".5\"/><path d=\"M12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7L11.25 12.1893L9.53033 10.4697C9.23744 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L11.4697 14.5303C11.6103 14.671 11.8011 14.75 12 14.75C12.1989 14.75 12.3897 14.671 12.5303 14.5303L15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697C15.2374 10.1768 14.7626 10.1768 14.4697 10.4697L12.75 12.1893V7Z\"/><path d=\"M8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z\"/></g>",
  "solar:lightbulb-bolt-bold-duotone": "<g fill=\"currentColor\"><path d=\"M4 9.67442C4 5.43595 7.35786 2 11.5 2C15.6421 2 19 5.43595 19 9.67442C19 11.9468 18.034 13.9892 16.5014 15.3934C15.9906 15.8614 15.6122 16.2082 15.344 16.4598C15.2099 16.5855 15.1074 16.6838 15.0317 16.7592C14.994 16.7968 14.9651 16.8266 14.9436 16.8496C14.933 16.861 14.925 16.8699 14.9192 16.8766C14.9133 16.8834 14.9108 16.8864 14.9108 16.8864C14.6743 17.1851 14.6231 17.2622 14.5926 17.332C14.5621 17.4018 14.5402 17.4922 14.4805 17.8717C14.457 18.0216 14.4545 18.2782 14.4545 18.9767V19.0067C14.4546 19.4158 14.4546 19.7687 14.4289 20.0583C14.4018 20.3645 14.3418 20.6677 14.1805 20.9535C14.001 21.2717 13.7428 21.5359 13.4318 21.7196C13.1525 21.8846 12.8562 21.946 12.557 21.9738C12.274 22 11.9292 22 11.5294 22H11.5293H11.4707H11.4706C11.0708 22 10.726 22 10.443 21.9738C10.1438 21.946 9.84747 21.8846 9.56818 21.7196C9.25723 21.5359 8.99902 21.2717 8.81949 20.9535C8.65825 20.6677 8.5982 20.3645 8.57107 20.0583C8.54543 19.7687 8.54544 19.4158 8.54545 19.0067L8.54545 18.9767C8.54545 18.2782 8.54305 18.0216 8.51949 17.8717C8.45982 17.4922 8.43787 17.4018 8.40739 17.332C8.3769 17.2622 8.32571 17.1851 8.0892 16.8864C8.0892 16.8864 8.08649 16.8831 8.0808 16.8766C8.07499 16.8699 8.06699 16.861 8.05635 16.8496C8.03486 16.8266 8.00601 16.7968 7.9683 16.7592C7.89262 16.6838 7.7901 16.5855 7.65601 16.4598C7.38782 16.2082 7.0094 15.8614 6.49859 15.3934C4.96602 13.9892 4 11.9468 4 9.67442Z\" opacity=\".5\"/><path d=\"M13.0848 19.6748H9.91463C9.9176 19.7718 9.92209 19.8565 9.92884 19.9327C9.94739 20.1422 9.97868 20.2182 10.0001 20.2562C10.06 20.3623 10.146 20.4504 10.2497 20.5116C10.2868 20.5335 10.3612 20.5656 10.5658 20.5845C10.7799 20.6044 11.0623 20.6051 11.4997 20.6051C11.9371 20.6051 12.2195 20.6044 12.4336 20.5845C12.6382 20.5656 12.7125 20.5335 12.7497 20.5116C12.8533 20.4504 12.9394 20.3623 12.9993 20.2562C13.0207 20.2182 13.052 20.1422 13.0706 19.9327C13.0773 19.8565 13.0818 19.7718 13.0848 19.6748Z\"/><path d=\"M12.6102 8.17688C12.9166 8.40084 12.9875 8.83658 12.7687 9.15012L11.5907 10.8376H12.9931C13.2485 10.8376 13.4825 10.9837 13.5993 11.2161C13.7162 11.4484 13.6963 11.7282 13.5479 11.9408L11.5998 14.7315C11.381 15.0451 10.9551 15.1177 10.6487 14.8937C10.3423 14.6698 10.2713 14.234 10.4902 13.9205L11.6682 12.233H10.2658C10.0104 12.233 9.77642 12.0869 9.65955 11.8545C9.54269 11.6222 9.56254 11.3424 9.71099 11.1298L11.659 8.33909C11.8779 8.02555 12.3037 7.95292 12.6102 8.17688Z\"/></g>",
  "solar:widget-5-linear": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"><path d=\"M13.5 15.5C13.5 13.6144 13.5 12.6716 14.0858 12.0858C14.6716 11.5 15.6144 11.5 17.5 11.5C19.3856 11.5 20.3284 11.5 20.9142 12.0858C21.5 12.6716 21.5 13.6144 21.5 15.5V17.5C21.5 19.3856 21.5 20.3284 20.9142 20.9142C20.3284 21.5 19.3856 21.5 17.5 21.5C15.6144 21.5 14.6716 21.5 14.0858 20.9142C13.5 20.3284 13.5 19.3856 13.5 17.5V15.5Z\"/><path d=\"M2 8.5C2 10.3856 2 11.3284 2.58579 11.9142C3.17157 12.5 4.11438 12.5 6 12.5C7.88562 12.5 8.82843 12.5 9.41421 11.9142C10 11.3284 10 10.3856 10 8.5V6.5C10 4.61438 10 3.67157 9.41421 3.08579C8.82843 2.5 7.88562 2.5 6 2.5C4.11438 2.5 3.17157 2.5 2.58579 3.08579C2 3.67157 2 4.61438 2 6.5V8.5Z\"/><path d=\"M13.5 5.5C13.5 4.56812 13.5 4.10218 13.6522 3.73463C13.8552 3.24458 14.2446 2.85523 14.7346 2.65224C15.1022 2.5 15.5681 2.5 16.5 2.5H18.5C19.4319 2.5 19.8978 2.5 20.2654 2.65224C20.7554 2.85523 21.1448 3.24458 21.3478 3.73463C21.5 4.10218 21.5 4.56812 21.5 5.5C21.5 6.43188 21.5 6.89782 21.3478 7.26537C21.1448 7.75542 20.7554 8.14477 20.2654 8.34776C19.8978 8.5 19.4319 8.5 18.5 8.5H16.5C15.5681 8.5 15.1022 8.5 14.7346 8.34776C14.2446 8.14477 13.8552 7.75542 13.6522 7.26537C13.5 6.89782 13.5 6.43188 13.5 5.5Z\"/><path d=\"M2 18.5C2 19.4319 2 19.8978 2.15224 20.2654C2.35523 20.7554 2.74458 21.1448 3.23463 21.3478C3.60218 21.5 4.06812 21.5 5 21.5H7C7.93188 21.5 8.39782 21.5 8.76537 21.3478C9.25542 21.1448 9.64477 20.7554 9.84776 20.2654C10 19.8978 10 19.4319 10 18.5C10 17.5681 10 17.1022 9.84776 16.7346C9.64477 16.2446 9.25542 15.8552 8.76537 15.6522C8.39782 15.5 7.93188 15.5 7 15.5H5C4.06812 15.5 3.60218 15.5 3.23463 15.6522C2.74458 15.8552 2.35523 16.2446 2.15224 16.7346C2 17.1022 2 17.5681 2 18.5Z\"/></g>",
  "solar:layers-minimalistic-bold-duotone": "<g fill=\"currentColor\"><g opacity=\".5\"><path d=\"M21.5011 15.4992C21.8095 15.2244 22.2827 15.2511 22.5587 15.5588C22.8349 15.8671 22.8092 16.3409 22.5011 16.6174L22.4992 16.6183L22.4982 16.6203L22.4933 16.6242L22.4796 16.6359C22.4685 16.6455 22.4528 16.6591 22.4337 16.675C22.3957 16.7067 22.342 16.7503 22.2726 16.8039C22.1331 16.9117 21.9298 17.0597 21.6632 17.2326C21.1301 17.5783 20.3426 18.0235 19.2999 18.4406L16.3761 19.6105C14.4994 20.3615 13.3793 20.8088 12.0001 20.8088C10.6209 20.8088 9.50094 20.3615 7.62416 19.6105L4.70033 18.4406C3.65766 18.0235 2.87014 17.5783 2.33705 17.2326C2.07048 17.0597 1.86716 16.9117 1.72767 16.8039C1.65797 16.75 1.60359 16.7067 1.56556 16.675C1.54657 16.6591 1.53174 16.6455 1.52064 16.6359L1.50697 16.6242L1.50209 16.6203L1.50111 16.6183L1.49916 16.6174C1.19132 16.3408 1.16542 15.867 1.44154 15.5588C1.71758 15.2511 2.19078 15.2244 2.49916 15.4992L2.50306 15.5021C2.50749 15.506 2.51556 15.5137 2.52748 15.5236C2.5515 15.5437 2.59056 15.5755 2.64466 15.6174C2.75339 15.7014 2.92265 15.8257 3.15248 15.9748C3.61227 16.273 4.31396 16.6708 5.25697 17.048L8.06556 18.1711C10.0904 18.981 10.9397 19.3088 12.0001 19.3088C13.0605 19.3088 13.9099 18.981 15.9347 18.1711L18.7423 17.048C19.6852 16.6709 20.387 16.273 20.8468 15.9748C21.0767 15.8257 21.2469 15.7014 21.3556 15.6174C21.4097 15.5755 21.4488 15.5436 21.4728 15.5236C21.4848 15.5136 21.4928 15.5059 21.4972 15.5021L21.4992 15.5002L21.5011 15.4992Z\"/><path d=\"M21.5011 11.4396C21.8095 11.165 22.2828 11.1916 22.5587 11.4992C22.8352 11.8075 22.8094 12.2822 22.5011 12.5588L22.4992 12.5597L22.4933 12.5656L22.4796 12.5773C22.4685 12.5869 22.4528 12.5995 22.4337 12.6154C22.3957 12.6472 22.3422 12.6915 22.2726 12.7453C22.1331 12.8531 21.9298 13.0011 21.6632 13.174C21.1302 13.5197 20.3424 13.964 19.2999 14.381L16.4913 15.5051L16.3761 15.551C14.4994 16.3019 13.3793 16.7502 12.0001 16.7502C10.6209 16.7502 9.50094 16.3019 7.62416 15.551L7.50892 15.5051L4.70033 14.381C3.65789 13.964 2.87011 13.5197 2.33705 13.174C2.07056 13.0012 1.86715 12.8531 1.72767 12.7453C1.65792 12.6914 1.60361 12.6472 1.56556 12.6154C1.54669 12.5996 1.53169 12.5869 1.52064 12.5773L1.50697 12.5656L1.50111 12.5597L1.49916 12.5588C1.191 12.2822 1.16509 11.8075 1.44154 11.4992C1.71758 11.1915 2.19078 11.1658 2.49916 11.4406L2.50306 11.4435C2.50754 11.4474 2.51578 11.4543 2.52748 11.464C2.55144 11.484 2.5905 11.5159 2.64466 11.5578C2.75335 11.6418 2.92276 11.7662 3.15248 11.9152C3.61224 12.2134 4.31404 12.6112 5.25697 12.9885L8.06556 14.1125C10.0904 14.9224 10.9397 15.2502 12.0001 15.2502C13.0605 15.2502 13.9099 14.9224 15.9347 14.1125L18.7423 12.9885C19.6854 12.6112 20.387 12.2134 20.8468 11.9152C21.0767 11.7661 21.2469 11.6418 21.3556 11.5578C21.4098 11.5159 21.4488 11.484 21.4728 11.464C21.4845 11.4542 21.4927 11.4474 21.4972 11.4435L21.5011 11.4396Z\"/></g><path d=\"M21.5011 11.4396C21.8095 11.165 22.2828 11.1916 22.5587 11.4992C22.8352 11.8075 22.8094 12.2822 22.5011 12.5588L22.4992 12.5597L22.4933 12.5656L22.4796 12.5773C22.4685 12.5869 22.4528 12.5995 22.4337 12.6154C22.3957 12.6472 22.3422 12.6915 22.2726 12.7453C22.1331 12.8531 21.9298 13.0011 21.6632 13.174C21.1302 13.5197 20.3424 13.964 19.2999 14.381L16.4913 15.5051L16.3761 15.551C14.4994 16.3019 13.3793 16.7502 12.0001 16.7502C10.6209 16.7502 9.50094 16.3019 7.62416 15.551L7.50892 15.5051L4.70033 14.381C3.65789 13.964 2.87011 13.5197 2.33705 13.174C2.07056 13.0012 1.86715 12.8531 1.72767 12.7453C1.65792 12.6914 1.60361 12.6472 1.56556 12.6154C1.54669 12.5996 1.53169 12.5869 1.52064 12.5773L1.50697 12.5656L1.50111 12.5597L1.49916 12.5588C1.191 12.2822 1.16509 11.8075 1.44154 11.4992C1.71758 11.1915 2.19078 11.1658 2.49916 11.4406L2.50306 11.4435C2.50754 11.4474 2.51578 11.4543 2.52748 11.464C2.55144 11.484 2.5905 11.5159 2.64466 11.5578C2.75335 11.6418 2.92276 11.7662 3.15248 11.9152C3.61224 12.2134 4.31404 12.6112 5.25697 12.9885L8.06556 14.1125C10.0904 14.9224 10.9397 15.2502 12.0001 15.2502C13.0605 15.2502 13.9099 14.9224 15.9347 14.1125L18.7423 12.9885C19.6854 12.6112 20.387 12.2134 20.8468 11.9152C21.0767 11.7661 21.2469 11.6418 21.3556 11.5578C21.4098 11.5159 21.4488 11.484 21.4728 11.464C21.4845 11.4542 21.4927 11.4474 21.4972 11.4435L21.5011 11.4396Z\" opacity=\".5\"/><path d=\"M12 3.25C13.3792 3.25 14.4992 3.69828 16.376 4.44922L19.3447 5.63672C20.2993 6.01854 21.0728 6.3282 21.6035 6.60645C21.872 6.74721 22.1324 6.90627 22.333 7.09863C22.5392 7.29638 22.75 7.59658 22.75 8C22.75 8.40342 22.5392 8.70362 22.333 8.90137C22.1324 9.09373 21.872 9.25279 21.6035 9.39355C21.0728 9.6718 20.2993 9.98147 19.3447 10.3633L16.376 11.5508C14.4992 12.3017 13.3792 12.75 12 12.75C10.6208 12.75 9.50081 12.3017 7.62402 11.5508L4.65527 10.3633C3.70069 9.98147 2.92722 9.6718 2.39648 9.39355C2.12801 9.25279 1.86758 9.09373 1.66699 8.90137C1.46083 8.70362 1.25 8.40342 1.25 8C1.25 7.59658 1.46083 7.29638 1.66699 7.09863C1.86758 6.90627 2.12801 6.74721 2.39648 6.60645C2.92723 6.3282 3.70068 6.01854 4.65527 5.63672L7.62402 4.44922C9.50081 3.69828 10.6208 3.25 12 3.25Z\"/></g>",
  "solar:question-circle-linear": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M10.125 8.875C10.125 7.83947 10.9645 7 12 7C13.0355 7 13.875 7.83947 13.875 8.875C13.875 9.56245 13.505 10.1635 12.9534 10.4899C12.478 10.7711 12 11.1977 12 11.75V13\"/><path stroke-linejoin=\"round\" d=\"M12 16H12.0001\"/></g>",
  "simple-icons:microsoft": "<path fill=\"currentColor\" d=\"M0 0v11.408h11.408V0zm12.594 0v11.408H24V0zM0 12.594V24h11.408V12.594zm12.594 0V24H24V12.594z\"/>",
  "simple-icons:ubuntu": "<path fill=\"currentColor\" d=\"M17.61.455a3.41 3.41 0 0 0-3.41 3.41a3.41 3.41 0 0 0 3.41 3.41a3.41 3.41 0 0 0 3.41-3.41a3.41 3.41 0 0 0-3.41-3.41M12.92.8C8.923.777 5.137 2.941 3.148 6.451a5 5 0 0 1 .26-.007a4.9 4.9 0 0 1 2.585.737A8.32 8.32 0 0 1 12.688 3.6A4.94 4.94 0 0 1 13.723.834A11 11 0 0 0 12.92.8m9.226 4.994a4.9 4.9 0 0 1-1.918 2.246a8.36 8.36 0 0 1-.273 8.303a4.9 4.9 0 0 1 1.632 2.54a11.16 11.16 0 0 0 .559-13.089M3.41 7.932A3.41 3.41 0 0 0 0 11.342a3.41 3.41 0 0 0 3.41 3.409a3.41 3.41 0 0 0 3.41-3.41a3.41 3.41 0 0 0-3.41-3.41zm2.027 7.866a4.9 4.9 0 0 1-2.915.358a11.1 11.1 0 0 0 7.991 6.698a11.2 11.2 0 0 0 2.422.249a4.88 4.88 0 0 1-.999-2.85a9 9 0 0 1-.836-.136a8.3 8.3 0 0 1-5.663-4.32zm11.405.928a3.41 3.41 0 0 0-3.41 3.41a3.41 3.41 0 0 0 3.41 3.41a3.41 3.41 0 0 0 3.41-3.41a3.41 3.41 0 0 0-3.41-3.41\"/>",
  "simple-icons:apple": "<path fill=\"currentColor\" d=\"M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04c-2.04.027-3.91 1.183-4.961 3.014c-2.117 3.675-.546 9.103 1.519 12.09c1.013 1.454 2.208 3.09 3.792 3.039c1.52-.065 2.09-.987 3.935-.987c1.831 0 2.35.987 3.96.948c1.637-.026 2.676-1.48 3.676-2.948c1.156-1.688 1.636-3.325 1.662-3.415c-.039-.013-3.182-1.221-3.22-4.857c-.026-3.04 2.48-4.494 2.597-4.559c-1.429-2.09-3.623-2.324-4.39-2.376c-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83c-1.207.052-2.662.805-3.532 1.818c-.78.896-1.454 2.338-1.273 3.714c1.338.104 2.715-.688 3.559-1.701\"/>"
};

/**
 * 内联 SVG 图标组件（替代 iconify-icon，无需任何外部脚本）
 * 用法：<di-icon icon="solar:xxx" :width="20" />，颜色取 currentColor
 */
const DiIcon = {
  name: 'DiIcon',
  functional: true,
  props: {
    icon: { type: String, required: true },
    width: { type: [Number, String], default: 20 }
  },
  render(h, ctx) {
    const p = ctx.props;
    const size = typeof p.width === 'number' ? p.width : parseFloat(p.width) || 20;
    return h('svg', {
      class: 'di-icon',
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        width: size,
        height: size,
        'aria-hidden': 'true'
      },
      domProps: { innerHTML: ICONS[p.icon] || '' }
    });
  }
};

/**
 * 下载统计 · 镜像详情（Vue2 版）
 *
 * 说明：
 * 1. Tailwind 已全部改写为原生 CSS（scoped），并做了响应式：移动端为全屏 App 布局，
 *    ≥768px 为居中宽栏布局，≥1024px 累计卡片与趋势图并排双列，不再固定 393×852。
 * 2. echarts 使用 npm 包直接 import；图标为内联 SVG（DiIcon），不依赖 CDN。
 * 3. 文字行高按原 Tailwind 设计语义设置（16px→24px、14px→20px、12px→16px，其余继承 1.5）。
 * 4. 镜像参数 mirror 同时支持 vue-router（this.$route.query）与普通 URL 查询串两种取参方式。
 * 5. 当前为静态 mock 数据，后续接接口时替换 data 中的 mirrors / channels 即可。
 */
export default {
  name: 'MirrorDetail',
  components: { DiIcon },
  data() {
    return {
      rangeOptions: {
        'seven_days': '近 7 天',
        'thirty_days': '近 30 天',
        'month': '本月'
      },
      mirrorKey: 'windows',
      range: 'seven_days',
      sortAsc: false,
      colorList: ['#67e8f9', '#60a5fa', '#a78bfa', '#fcd34d', '#fb7185', '#bef264', '#fb923c', '#93c5fd', '#fdba74', '#e2e8f0'],
      channels: [],
      currentMirror: {
        total: '6,284',
        growth: '+21.8%',
        avg: '898',
        peak: '09/03',
        rate: '48.9',
        dates: ['08/29', '08/30', '08/31', '09/01', '09/02', '09/03', '09/04'],
        values: [806, 842, 914, 873, 931, 1038, 880]
      }
    };
  },
  created() {
    // 非响应式实例属性，不放入 data，避免 Vue 深度遍历 echarts 实例
    this.chart = null;
    // 取参：优先 vue-router 的 query，其次 URL 查询串
    if (this.$route && this.$route.query && this.$route.query.file && this.$route.query.range) {
      this.mirrorKey = this.$route.query.file;
      this.range = this.$route.query.range;
    }
    this.getSystemStatisticsDetailHandle()
    this.getSystemStatisticsDetailByDriveHandle()
  },
  computed: {
    sortedChannels() {
      const list = this.channels.slice();
      return this.sortAsc ? list.reverse() : list;
    },
    sortLabel() {
      return this.sortAsc ? '占比从低到高' : '按次数';
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getSystemStatisticsDetailHandle() {
      getSystemStatisticsDetail({
        file: this.mirrorKey,
        range: this.range
      }).then(res => {
        this.currentMirror.dates = res.data.daily_list.map(item => item.date)
        this.currentMirror.values = res.data.daily_list.map(item => item.num)
        this.currentMirror.avg = res.data.avg_num
        this.currentMirror.peak = res.data.max_day.date
        this.currentMirror.rate = res.data.proportion
        this.currentMirror.total = res.data.today.num
        this.currentMirror.growth = res.data.today.prev_rate
        this.renderChart()
      })
    },
    getSystemStatisticsDetailByDriveHandle() {
      getSystemStatisticsDetailByDrive({
        file: this.mirrorKey,
        range: this.range
      }).then(res => {
        this.channels = res.data.list
      })
    },
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    },
    initChart() {
      this.chart = echarts.init(this.$refs.detailChart);
      this.renderChart();
    },
    renderChart() {
      if (!this.chart) return;
      const data = this.currentMirror;
      this.chart.setOption({
        grid: { left: 4, right: 4, top: 16, bottom: 4, containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: data.dates, axisLine: { lineStyle: { color: '#26384e' } }, axisTick: { show: false }, axisLabel: { color: '#71839b', fontSize: 10, margin: 12 } },
        yAxis: { type: 'value', splitNumber: 3, axisLabel: { color: '#71839b', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(148,163,184,0.09)' } }, axisLine: { show: false } },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#15263c',
          borderColor: '#2a425f',
          textStyle: { color: '#e2e8f0', fontSize: 11 },
          formatter: params => params[0].axisValue + '<br/><b>' + params[0].value.toLocaleString() + '</b> 次下载'
        },
        series: [{
          data: data.values,
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 3, color: '#34d399' },
          itemStyle: { color: '#34d399', borderColor: '#10243a', borderWidth: 2 },
          areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(52,211,153,.22)' }, { offset: 1, color: 'rgba(52,211,153,0)' }] } }
        }]
      });
    },
    handleResize() {
      if (this.chart) this.chart.resize();
    }
  }
};
</script>

<style scoped>
/* ===== 图标基础 ===== */
.di-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}

/* ===== 基础布局（响应式：移动端全屏 App 壳 / PC 端居中宽栏） ===== */
.dl-root {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  background: #050b16;
}
.dl-home {
  position: relative;
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #09111f;
  color: #f1f5f9;
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  line-height: 1.5;
}
.dl-home,
.dl-home * {
  box-sizing: border-box;
}
.dl-home a {
  color: inherit;
  text-decoration: none;
}
.dl-home strong {
  font-weight: 700;
}

/* ===== 顶部标题栏 ===== */
.dl-header {
  flex-shrink: 0;
  padding: 20px 20px 16px;
  background: #0b1526;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.dl-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dl-back-btn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
  flex-shrink: 0;
}
.dl-header-center {
  font-size: 12px;
  line-height: 16px;
  color: #94a3b8;
}
.dl-mirror-head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.dl-mirror-badge {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: rgba(96,165,250,.1);
  color: #93c5fd;
}
.dl-mirror-from {
  font-size: 11px;
  color: rgba(103, 232, 249, 0.8);
  letter-spacing: 0.12em;
}
.dl-mirror-title {
  margin-top: 4px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: #f1f5f9;
}

/* ===== 滚动内容区 ===== */
.dl-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.dl-scroll::-webkit-scrollbar {
  display: none;
}
.dl-page {
  padding: 20px 20px 32px;
}

/* ===== 累计下载卡片 + 趋势图（PC 端并排） ===== */
.dl-detail-cols {
  display: block;
}
.dl-summary-card {
  border-radius: 24px;
  background: #101d31;
  border: 1px solid rgba(255, 255, 255, 0.07);
  padding: 16px;
}
.dl-summary-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}
.dl-summary-label {
  font-size: 12px;
  line-height: 16px;
  color: #94a3b8;
}
.dl-summary-nums {
  margin-top: 4px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.dl-summary-value {
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
}
.dl-summary-delta {
  font-size: 12px;
  line-height: 16px;
  color: #6ee7b7;
  white-space: nowrap;
}
.dl-summary-range {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
}
.dl-summary-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 16px;
}
.dl-summary-cell-k {
  font-size: 11px;
  color: #64748b;
}
.dl-summary-cell-v {
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
}

/* ===== 下载趋势 ===== */
.dl-trend-head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.dl-section-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}
.dl-trend-sub {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}
.dl-badge-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #6ee7b7;
  white-space: nowrap;
}


.dl-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #6ee7b7;
  flex-shrink: 0;
}
.dl-chart-card {
  margin-top: 12px;
  border-radius: 24px;
  background: #101d31;
  border: 1px solid rgba(255, 255, 255, 0.07);
  padding: 16px;
}
.dl-chart {
  width: 100%;
  height: 224px;
}

/* ===== 下载方式明细 ===== */
.dl-channel-head {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.dl-sort-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #67e8f9;
  background: none;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
  flex-shrink: 0;
  white-space: nowrap;
}
.dl-channel-list {
  margin-top: 12px;
  border-radius: 24px;
  background: #101d31;
  border: 1px solid rgba(255, 255, 255, 0.07);
}
.dl-channel-item {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.dl-channel-item + .dl-channel-item {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
.dl-channel-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #67e8f9;
}
.dl-channel-body {
  min-width: 0;
  flex: 1;
}
.dl-channel-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  line-height: 16px;
}
.dl-channel-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.dl-channel-nums {
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}
.dl-channel-percent {
  font-weight: 400;
  color: #64748b;
  margin-left: 4px;
}
.dl-channel-bar {
  margin-top: 8px;
  height: 6px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.06);
  overflow: hidden;
}
.dl-channel-bar-fill {
  height: 100%;
  border-radius: 9999px;
}

/* ===== PC 端（≥768px）：居中宽栏 ===== */
@media (min-width: 768px) {
  .dl-root {
    padding: 40px 24px;
    align-items: flex-start;
  }
  .dl-home {
    max-width: 880px;
    min-height: auto;
    height: auto;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    box-shadow: 0 40px 90px -20px rgba(0, 0, 0, 0.6);
  }
  .dl-scroll {
    overflow: visible;
  }
  .dl-header {
    padding: 24px 32px 20px;
  }
  .dl-page {
    padding: 24px 32px 36px;
  }
  .dl-toast {
    bottom: 32px;
  }
}

/* ===== PC 端（≥1024px）：累计卡片与趋势图并排 ===== */
@media (min-width: 1024px) {
  .dl-detail-cols {
    display: grid;
    grid-template-columns: 5fr 7fr;
    gap: 24px;
    align-items: start;
  }
  .dl-detail-cols .dl-trend-head {
    margin-top: 0;
  }
}

/* ===== 大屏 PC（≥1200px）：进一步放宽 ===== */
@media (min-width: 1200px) {
  .dl-root {
    padding: 56px 32px;
  }
  .dl-home {
    max-width: 960px;
  }
  .dl-page {
    padding: 28px 40px 44px;
  }
  .dl-header {
    padding: 28px 40px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/MirrorDetail.vue